import VerticalLine_VerticalShadowLeftLineComponent from '@wix/thunderbolt-elements/src/components/VerticalLine/viewer/skinComps/BaseVerticalLine/VerticalShadowLeftLine.skin';
import VerticalLine_VerticalShadowLeftLineController from '@wix/thunderbolt-elements/src/components/VerticalLine/viewer/VerticalLine.controller';


const VerticalLine_VerticalShadowLeftLine = {
  component: VerticalLine_VerticalShadowLeftLineComponent,
  controller: VerticalLine_VerticalShadowLeftLineController
};


export const components = {
  ['VerticalLine_VerticalShadowLeftLine']: VerticalLine_VerticalShadowLeftLine
};

